import React, { useState } from "react";
import "../styles/navbar.css"; 
import { GiHamburgerMenu } from "react-icons/gi";
import resume from "../Images/Gaurav-Sharma-Resume.pdf";
import { Link } from "react-scroll";
import Theme from "./Theme";
import { useTheme } from "../theme/themeContext";

export const Navbar = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const {darkMode , toggleDark} = useTheme();
  // console.log(darkMode)

  const handleresume = () => {
    window.open('https://drive.google.com/file/d/1K_E_Che5KBduqgsZBifmblJuUoy90pmA/view?usp=sharing');
  };

  return (
    <div id="nav-menu">
      <nav className={`w-full h-[8.5rem] fixed  flex justify-between items-center p-5 shadow-md transition-shadow duration-300 ease-in-out ${darkMode ? 'bg-white':'bg-black'}`}>
        {/* LOGO */}
        <div className={`text-6xl pl-20 ${darkMode ?  'text-black'  : 'text-gray-400'} ${darkMode ? 'bg-white' : 'bg-black'}  `}>
          <h2>Gaurav</h2>
        </div>

        {/* MENU LINKS */}
        <div className={`menu-link ${menuVisible ? "hidden" : "hidden"} md:flex md:space-x-4 transition-all duration-300 ease-in-out`}>
          <ul className={`flex text-3xl flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-24 ${darkMode ? 'text-black' : 'text-gray-400'}  cursor-pointer`}>
            <li>
              <Link to="home" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}>
                Home
              </Link>
            </li>
            <li>
              <Link to="about" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}>
                About
              </Link>
            </li>
            <li>
              <Link to="skills" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}>
                Skills
              </Link>
            </li>
            <li>
              <Link to="projects" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="contact" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}>
                Contact
              </Link>
            </li>
            <li>
              <a
                href={resume}
                target="_blank"
                download="Gaurav-Sharma-Resume.pdf"
                className="nav-link resume"
                id="resume-link-1"
              >
                <Link
                  id="resume-button-1"
                  onClick={handleresume}
                  className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}
                >
                  Resume
                </Link>
              </a>
            </li>
          </ul>
        </div>

        {/* Theme Toggle */}
        <div className="pr-20">
        <label className="swap swap-rotate">

  <input type="checkbox" className="theme-controller" value="synthwave" onChange={toggleDark} />

  {/* sun icon */}
  <svg
    className="swap-off h-20 w-20 fill-current text-gray-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24">
    <path
      d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
  </svg>

  {/* moon icon */}
  <svg
    className="swap-on h-20 w-20 fill-current text-black"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24">
    <path
      d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
  </svg>

</label>
        </div>

        {/* Hamburger Menu */}
        <div className="hamburger-menu pr-20 md:hidden">
          <a href="#" onClick={() => setMenuVisible(!menuVisible)}>
            <GiHamburgerMenu className={`text-5xl ${darkMode ? 'text-black' : 'text-gray-400'}`} />
          </a>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {menuVisible && (   
        <div className={`absolute top-28  left-0 w-full h-[200px] ${darkMode ? 'bg-white' : 'bg-black'}  shadow-lg p-10  transition-all duration-300 ease-in-out md:hidden`}>
          <ul className={`flex flex-col space-y-6 ${darkMode ? 'text-black' : 'text-gray-400'}  text-2xl`}>
            <li>
              <Link to="home" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}onClick={() => setMenuVisible(false)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="about" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `} onClick={() => setMenuVisible(false)}>
                About
              </Link>
            </li>
            <li>
              <Link to="skills" smooth={true} duration={800}  className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `} onClick={() => setMenuVisible(false)}>
                Skills
              </Link>
            </li>
            <li>
              <Link to="projects" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}onClick={() => setMenuVisible(false)}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="contact" smooth={true} duration={800} className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}onClick={() => setMenuVisible(false)}>
                Contact
              </Link>
            </li>
            <li>
              <a
                href={resume}
                target="_blank"
                download="Gaurav-Sharma-Resume.pdf"
                id="resume-link-1"
                >
                <button
                  id="resume-button-1"
                  className={`${darkMode ? 'hover:text-gray-400' : 'hover:text-white'} `}
                  onClick={handleresume}
                >
                  Resume
                </button>
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

